export {
  getUserAgentInfo
} from './navigators.helpers'

export {
  isSafari,
  getFilteredPublications
} from './publications.helpers'

export {
  getUserSubscriptionPlan
} from './subscription.helpers'

export {
  getCampaingsFiltered
} from './campaings.helpers'

export {
  getDiscountVouchersFiltered
} from './discount-vouchers.helpers'


export {
  updateUserCookies
} from './users.helpers'

export {
  OTHER_REASON_ID
} from './offset-reasons.helpers'

export {
  getFilteredUserSaleOffers,
  getFilteredOfferSaleGroups,
  convertSaleOfferIntoUserSaleOffer,
  getAdminSaleOffersFiltered
} from './sale-offers.helpers'

export {
  getIntegrationPurchaseBuyerData,
  getBuyerDataOrdered,
  getIntegrationsFiltered,
  getIntegrationPurchasesFiltered
} from './developers.helpers'

export {
  getInvoiceFilePayload
} from './download-invoices.helpers'

export {
  ACCOUNT_PAGES
} from './pages.helper'

export {
  gtm_view
} from './gtm-helpers'

export {
  currencySymbolMap
} from './currencies/code-symbol.array'

export {
  showNotification
} from './notifications'

export {
  showToast
} from './messages-toast'

export {
  downloadCsv,
  getCsvFromObjectArray
} from './csv-download'

export {
  isUUID,
  removeAccents,
  getLastSubstring,
  getFirstSubstring,
  isEmailValid,
  isNumber,
  getStringWithOutColomns,
  getSubstringSpaceReplaced
} from './string-builder.helper'

export {
  getActualDateFormated,
  getTransformedDate,
  getDateFormatted,
  getNaturalDate,
  getHumanizeDate,
  getSmallTransformedDate,
  getDateFormattedSmall,
  getTransformedDateTime,
  transformDate3
} from './date-helpers'

export {
  forgotPassword,
  logout,
  isNotAuthRequest,
  isOtherAPI,
  handleLoginSuccess,
  mustRefreshTheToken,
  updateAuthCookiesAndLocalStorage
} from './auth'

export {
  getFileFormUrl,
  readExcelFile,
  getImageBase64,
  getFileFromBlobUrl,
  exportPdfZip,
  readFileAsBuffer,
  getImageDimensions,
  getFileSizeInMB,
  getImageDimensionsSizeOf,
  convertToExcel,
  exportXLSXZip,
} from './files'

export {
  isNotTypeOnArray
} from './array'

export {
  emailRE,
  youtubeUrlRE,
  urlRE,
  accentsRE,
  urlREStr,
  registryREurl,
  youtubeUrlStr
} from './regular-expressions'

export {
  purchasesDateFormatDashboard,
  extractFormData,
  prepareMonthChart,
  prepareChart,
  getCurrencyToken
} from  './summary.helpers'

export {
  getOfferStatus,
} from './offers.helpers'

export {
  languages
} from './languages'

export {
  setNewCtSidCookie,
  updateCtSidCookie,
  setNewCtVidCookie,
  updateCtVidCookie,
  checkLoggedInCookie,
  setLoginCookie,
  updateCTCookie,
  getCtCookie
} from './cookies.helpers'

export {
  getSymbolFromCurrency,
  getFormatedPrice
} from './currency.helpers'

export {
  ExcelFile
} from './excel.helpers'


export {
  getOrderItemUnit,
  getOrderItemTotal,
  getOrderItemVatAmount,
  getOrderItemFeeAmount,
  getOrderItemTransactionFeeAmount,
  getOrderItemTransactionAmount,
  getOrderItemUnitPrice,
  getOrderItemProjectUnitPrice,
  getOrderItemVatAmountForCustomerInvoice
} from './orders.helpers'

export {
  getSaleStatus,
  getSaleImage,
  getSaleBlockchainCertificate,
  downloadSaleCsvFile,
  getBigSaleStatus,
  getBigSaleBlockchainCertificate,
  getBigSaleProjectImage,
  getBigSaleUnit,
  getSaleBejalfOf,
  getSaleCertificateLanguage,
  getSalePrices,
  getCTFeesInvoice,
  getSaleVatInvoice,
  getSupplierInvoice
} from './sales.helpers'

export {
  emailListIsValid
} from './stock-alerts.helpers'

export {
  filteredOptions,
  getDescriptionLanguages,
  getProjectKind,
  getProjectsFiltered,
  getProjectUnit,
  getProjectUnitUd,
  getVintageAvailableStock,
  getVintageAvailableYears,
  isHtmlTextEmpty,
  projectIsOutOfStock,
  getProjectOptionName,
  getProjectHeadline
} from './project-helpers'

export {
  getUserAdminName,
  getUserAdminNameOrdered,
  getFilteredUsers
} from './validate-users.helpers'

export {
  getWithdrawalUserName,
  getWithdrawalCompany,
  getFilteredWithdrawals,
  getWithdrawalStatusTags
} from './withdrawal-helpers'

export {
  getPurchaseDocumentBuyer,
  getFilteredDocuments
} from './validate-documents.helpers'

export {
  getTransferUser,
  getTransfersFiltered,
  getTransferCompanyName,
  getTransferOrderedyByDate
} from './validate-transfers.helpers'

export {
  getOptionalFieldWithExcelData,
  getOffsetPreviewErrorLabel
} from './offset-by-excel.helpers'

export {
  getAdminDepositUser,
  getAdminDepositCompany,
  getAdminDepositsFiltered
} from './validate-deposits.helpers'

export {
  transformArray,
  validateCabifyCSVFile
} from './manage-cabify-process.helpers'
